import React from 'react';

export const SessionExpiredPage: React.FC = () => {
  return <div>Your token expired</div>;
};
